// extracted by mini-css-extract-plugin
export default {"content":"WarningTooltip_content__DyEe4","icon":"WarningTooltip_icon__KA+OV","message":"WarningTooltip_message__hd6fl"};